import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	DiscountLabelFlag,
	DiscountLabelText,
	DiscountLabelFlagFirstFree,
	DiscountLabelTextFirstFree
} from './styles';

class DiscountLabel extends PureComponent {
	render() {
		const {
			currencySymbol,
			discountStr,
			discountType,
			dealDiscount,
			dealDiscountType,
			dealDiscountAmount
		} = this.props;

		if (!discountStr && !dealDiscount) return null;

		let discountText = discountStr;
		// Format % off coupons
		if (discountText) {
			if (discountText.startsWith("-")) {
				discountText = discountText.slice(1);
			}
			discountText += ' Off';
		}

		// Format Deal coupon text
		if (dealDiscount) {
			discountText = dealDiscount.includes("%") ? dealDiscount : (
				`${currencySymbol}${dealDiscount} Off`
			);
		}

		let showFirstBoxFree = false;
		if (dealDiscount && dealDiscountType === 4 && dealDiscountAmount === 100) {
			// Show "First Box Free" if card is in a deal, where the deal is % off first shipment
			// and % is 100
			showFirstBoxFree = true;
		} else if (!dealDiscount && discountType === 4 && discountText === "100% Off") {
			// If the above statement isn't true then
			// check if the card isn't in a deal, but the seller has set up a % off first shipment
			// and % is 100
			showFirstBoxFree = true;
		}

		if (showFirstBoxFree) {
			return (
				<DiscountLabelFlagFirstFree>
					<DiscountLabelTextFirstFree>
						<div>First</div>
						<div>Box Free</div>
					</DiscountLabelTextFirstFree>
				</DiscountLabelFlagFirstFree>
			);
		} else {
			return (
				<DiscountLabelFlag>
					<DiscountLabelText>{discountText}</DiscountLabelText>
				</DiscountLabelFlag>
			);
		}
	}
}

DiscountLabel.propTypes = {
	currencySymbol: PropTypes.string,
	discountStr: PropTypes.string,
	dealDiscount: PropTypes.string,
	discountType: PropTypes.number,
	dealDiscountType: PropTypes.number,
	dealDiscountAmount: PropTypes.number,
};

DiscountLabel.defaultProps = {
	currencySymbol: "$",
	dealDiscount: "",
};

export default DiscountLabel;
